document.addEventListener("DOMContentLoaded", () => {

  function replaceYotpoStars() {

    document.querySelectorAll(".el-product-card__rating").forEach(card => {

      const label = card.querySelector('[role="img"]')?.getAttribute("aria-label");
      const reviewText = card.querySelector(".yotpo-sr-bottom-line-text")?.textContent;

      if (!label || !reviewText) return;

      const ratingMatch = label.match(/([0-9.]+) out/);
      const reviewsMatch = label.match(/total ([0-9]+)/);

      if (!ratingMatch || !reviewsMatch) return;

      const rating = ratingMatch[1];
      const reviews = reviewsMatch[1];

      card.innerHTML = `<svg class="yotpo-custom-star" xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15" fill="none"><path d="M7.33882 0.917969C7.54796 0.917993 7.74278 1.0248 7.85512 1.2012L9.85025 4.33644L13.252 4.9035C13.4724 4.94023 13.6551 5.09419 13.7288 5.30504C13.8026 5.51592 13.7558 5.75025 13.6064 5.91632L11.0465 8.75997L11.6148 12.4504C11.649 12.6728 11.5584 12.8961 11.3788 13.0318C11.1992 13.1672 10.9595 13.1936 10.7549 13.0999L7.33882 11.5337L3.92276 13.0999C3.71821 13.1935 3.47848 13.1673 3.29894 13.0318C3.11945 12.8961 3.02871 12.6727 3.06291 12.4504L3.63057 8.75997L1.07134 5.91632C0.921961 5.75028 0.874572 5.51588 0.948247 5.30504C1.02198 5.09419 1.20536 4.94028 1.42568 4.9035L4.82683 4.33644L6.82259 1.2012L6.8686 1.13846C6.98394 0.999868 7.15594 0.918018 7.33882 0.917969ZM5.71356 5.22378C5.62033 5.37023 5.46893 5.4701 5.29768 5.49865L2.7271 5.92648L4.73421 8.15709C4.85704 8.29354 4.91211 8.47814 4.88419 8.65956L4.44501 11.5134L7.08367 10.3046L7.14584 10.2801C7.29202 10.2315 7.45245 10.2398 7.59397 10.3046L10.2321 11.5134L9.79353 8.65956C9.76563 8.47814 9.82076 8.29354 9.9435 8.15709L11.95 5.92648L9.38003 5.49865C9.20883 5.47007 9.05733 5.37018 8.96414 5.22378L7.33882 2.66933L5.71356 5.22378Z" fill="#151803"/></svg> 
      <span class="yotpo-custom-rating">${rating}</span>
      <span class="yotpo-custom-reviews">(${reviews})</span>`;

    });

  }

  replaceYotpoStars();

  const observer = new MutationObserver(replaceYotpoStars);
  observer.observe(document.body, { childList: true, subtree: true });

});